import * as actions from './actions';
import { responseStatus } from '../../utils/constants';

export type State = {
  loading: boolean;
  yodleeConsent: Array<Record<string, any>>;
  error: Record<string, string>;
  yodleeConsentLoaded?: string;
  yodleeRefresh?: string;
};

export default (
  state: State = {
    yodleeConsent: [],
    error: {},
    loading: false,
    yodleeRefresh: responseStatus.SUCCESS,
  },
  action: any,
): State => {
  switch (action.type) {
    case actions.FETCH_YODLEE_CONSENT:
      return {
        ...state,
        loading: true,
        yodleeConsentLoaded: 'inProgress',
      };
    case actions.FETCH_YODLEE_CONSENT_SUCCESS:
      return {
        ...state,
        yodleeConsent: action.payload,
        loading: false,
        yodleeConsentLoaded: responseStatus.SUCCESS,
      };
    case actions.FETCH_YODLEE_CONSENT_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        yodleeConsentLoaded: responseStatus.ERROR,
      };
    case actions.YODLEE_REFRESH:
      return {
        ...state,
        yodleeRefresh: 'inProgress',
      };
    case actions.YODLEE_REFRESH_SUCCESS:
      return {
        ...state,
        yodleeRefresh:
          action.payload.err || action.payload.yodleeAccountSummary === null
            ? responseStatus.ERROR
            : responseStatus.SUCCESS,
      };
    case actions.YODLEE_REFRESH_ERROR:
      return {
        ...state,
        yodleeRefresh: responseStatus.ERROR,
      };
    default:
      return state;
  }
};
